import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { FEATURE_TYPES } from "./Feature";
var inv255 = 1 / 255;

function rgba2rgb(orig) {
  var result = orig.match(/(?:((hsl|rgb)a? *\(([\d.%]+(?:deg|g?rad|turn)?)[ ,]*([\d.%]+)[ ,]*([\d.%]+)[ ,/]*([\d.%]*)\))|(#((?:[\d\w]{3}){1,2})([\d\w]{1,2})?))/i);

  if (!result) {
    return {
      color: orig,
      opacity: 1.0
    };
  } else if (result[7]) {
    var opacity = 1.0;

    if (result[9]) {
      opacity = parseInt(result[9].length == 1 ? "".concat(result[9]).concat(result[9]) : result[9], 16) * inv255;
    }

    return {
      color: "#".concat(result[8]),
      opacity: opacity
    };
  } else if (result[0]) {
    return {
      color: "".concat(result[2], "(").concat(result[3], ",").concat(result[4], ",").concat(result[5], ")"),
      opacity: Number(result[6]) || 1.0
    };
  }
}
/**
 * Style defines {@link Feature} style.
 */


var Style =
/*#__PURE__*/
function () {
  /**
   * @constructor
   * @param {object} [params]
   * @param {object} [params.fill] fill style.
   * @param {string} [params.fill.color] fill color string css.
   * @param {number} [params.fill.opacity] fill opacity.
   * @param {object} [params.stroke] stroke style.
   * @param {string} [params.stroke.color] stroke color string css.
   * @param {number} [params.stroke.opacity] stroke opacity.
   * @param {number} [params.stroke.width] stroke line width.
   * @param {object} [params.point] point style.
   * @param {string} [params.point.color] point color string css.
   * @param {string} [params.point.line] point line color string css.
   * @param {number} [params.point.width] point line width.
   * @param {number} [params.point.opacity] point opacity.
   * @param {number} [params.point.radius] point line radius
   */
  function Style() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Style);

    this.isStyle = true;
    params.fill = params.fill || {};
    params.stroke = params.stroke || {};
    params.point = params.point || {};
    this.fill = {
      color: params.fill.color,
      opacity: params.fill.opacity
    };
    this.stroke = {
      color: params.stroke.color,
      opacity: params.stroke.opacity,
      width: params.stroke.width
    };
    this.point = {
      color: params.point.color,
      line: params.point.line,
      opacity: params.point.opacity,
      radius: params.point.radius,
      width: params.point.width
    };
  }
  /**
   * set Style from geojson properties.
   * @param {object} properties geojson properties.
   * @param {number} type
   * @returns {Style}
   */


  _createClass(Style, [{
    key: "setFromGeojsonProperties",
    value: function setFromGeojsonProperties(properties, type) {
      if (type === FEATURE_TYPES.POINT) {
        this.point.color = properties.fill || 'white';
        this.point.opacity = properties['fill-opacity'] || 1.0;
        this.point.line = properties.stroke || 'gray';
        this.point.radius = properties.radius || 2.0;
      } else {
        this.stroke.color = properties.stroke;
        this.stroke.width = properties['stroke-width'];
        this.stroke.opacity = properties['stroke-opacity'];

        if (type !== FEATURE_TYPES.LINE) {
          this.fill.color = properties.fill;
          this.fill.opacity = properties['fill-opacity'] || 1.0;
        }
      }

      return this;
    }
    /**
     * set Style from vector tile layer properties.
     * @param {object} layer vector tile layer.
     * @returns {Style}
     */

  }, {
    key: "setFromVectorTileLayer",
    value: function setFromVectorTileLayer(layer) {
      if (layer.type === 'fill' && !this.fill.color) {
        var _rgba2rgb = rgba2rgb(layer.paint['fill-color']),
            color = _rgba2rgb.color,
            opacity = _rgba2rgb.opacity;

        this.fill.color = color;
        this.fill.opacity = layer.paint['fill-opacity'] || opacity || 1.0;
      }

      if (layer.type === 'line' && !this.stroke.color) {
        var _rgba2rgb2 = rgba2rgb(layer.paint['line-color']),
            _color = _rgba2rgb2.color,
            _opacity = _rgba2rgb2.opacity;

        this.stroke.color = _color;

        if ('line-width' in layer.paint) {
          this.stroke.width = layer.paint['line-width'].base || 3.0;
        }

        this.stroke.opacity = layer.paint['line-opacity'] || _opacity || 1.0;
      }

      if (layer.type === 'symbol') {
        var _rgba2rgb3 = rgba2rgb(layer.paint['text-color']),
            _color2 = _rgba2rgb3.color,
            _opacity2 = _rgba2rgb3.opacity;

        this.point.color = _color2;
        this.point.opacity = _opacity2;
        this.point.radius = 1.5;
      }

      return this;
    }
  }]);

  return Style;
}();

export default Style;